import React from 'react';
import { IconBrandReturn } from '@tvg/fuse/icon/all';
import { IconElement } from '@tvg/fuse/icon-element';
import { Link } from '@tvg/fuse/link';
import { Divider } from '@tvg/fuse/divider';
import { Typography } from '@tvg/fuse/typography';
import { NonReturnableInfoProps } from './NonReturnableInfoProps';
import styles from './NonReturnableInfo.module.css';

const RETURNABLE_CARD_TITLE = 'Returns Policy';

function NonReturnableInfo({ returnable }: NonReturnableInfoProps): JSX.Element {
  const { beforeLink, link } = returnable;

  return (
    <div className={styles.container} data-testid="non-returnable-wrapper">
      <div className={styles.headingContainer}>
        <div className={styles.iconContainer}>
          <IconElement
            icon={<IconBrandReturn />}
            responsiveSize="small"
            dataTestId="delivery-card-icon"
            srLabel="Returns policy"
          />
        </div>
        <Typography tag="h2" type="heading" size="1" data-testid="delivery-card-title">
          {RETURNABLE_CARD_TITLE}
        </Typography>
      </div>
      <Typography size="m1" tag="p" type="paragraph">
        {`${beforeLink} `}
      </Typography>
      {link && (
        <Link href={link.href} data-testid="return-link" target="_blank" size="medium">
          {link.text}
        </Link>
      )}
      <div className={styles.dividerContainer}>
        <Divider />
      </div>
    </div>
  );
}

export default NonReturnableInfo;
